import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import LiveChat from "@/components/LiveChat";
import { Outlet } from "react-router-dom";
import { useEffect } from "react";

function ScrollToTop() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return null;
}

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <ScrollToTop />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <LiveChat />
    </div>
  );
}
